import React from 'react';
import { siteData } from '../data/mock';

const HeroSection = () => {
  const scrollToForSection = () => {
    const forSection = document.querySelector('[data-section="for-section"]');
    if (forSection) {
      forSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative w-full">
      {/* Video background container */}
      <div
        className="relative overflow-hidden"
        style={{
          width: '100%',
          aspectRatio: '1212 / 691',
          background: 'linear-gradient(180deg, #87CEEB 0%, #B0E0E6 40%, #fff 100%)',
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          style={{ zIndex: 0 }}
        >
          <source src="/assets/wispysky.mp4" type="video/mp4" />
        </video>

        {/* Content overlay */}
        <div
          className="absolute inset-0 flex flex-col items-center justify-center"
          style={{ zIndex: 1, paddingTop: '20px', paddingLeft: 'var(--page-gutter)', paddingRight: 'var(--page-gutter)' }}
        >
          {/* Main heading */}
          <h1
            className="text-center"
            style={{
              fontFamily: 'Coolvetica, sans-serif',
              fontWeight: 400,
              letterSpacing: '-0.025em',
              lineHeight: '1.05',
            }}
          >
            <span style={{ fontSize: 'clamp(40px, 5.5vw, 80px)', color: '#fff' }}>
              {siteData.hero.headingLine1}{' '}
            </span>
            <span style={{ fontSize: 'clamp(40px, 5.5vw, 80px)', color: '#FF98BF' }}>
              {siteData.hero.headingHighlight1}
            </span>
            <br />
            <span style={{ fontSize: 'clamp(40px, 5.5vw, 80px)', color: '#fff' }}>
              {siteData.hero.headingLine2}{' '}
            </span>
            <span style={{ fontSize: 'clamp(40px, 5.5vw, 80px)', color: '#FF98BF' }}>
              {siteData.hero.headingHighlight2}
            </span>
          </h1>

          {/* Subtitle */}
          <p
            className="text-center"
            style={{
              fontFamily: 'InterVariable, sans-serif',
              fontSize: 'clamp(14px, 1.4vw, 18px)',
              fontWeight: 400,
              fontStyle: 'italic',
              color: '#000',
              maxWidth: 'min(520px, calc(100vw - 2 * var(--page-gutter)))',
              marginTop: '20px',
              lineHeight: '1.4',
            }}
          >
            {siteData.hero.subtitle}
          </p>

          {/* CTA Button — glass morphism style */}
          <div className="flex gap-4" style={{ marginTop: '24px' }}>
            <button
              onClick={scrollToForSection}
              className="cta-btn-macos"
              style={{
                fontFamily: 'InterVariable, sans-serif',
                fontSize: '16px',
                fontStyle: 'italic',
                fontWeight: 500,
                color: '#000',
                background: 'rgba(255, 255, 255, 0.25)',
                border: '1.5px solid #FF98BF',
                borderRadius: '24px',
                padding: '10px clamp(18px, 5vw, 28px)',
                cursor: 'pointer',
                letterSpacing: '-0.025em',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                boxShadow: '0 4px 16px rgba(255, 152, 191, 0.2), inset 0 1px 1px rgba(255, 255, 255, 0.4)',
              }}
            >
              we built it for you
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
